import { ACTION_TYPES } from 'lib/Constants'

const {
    CLEAR_CAN_ADD_CLIENT,
    CLEAR_CAN_ADD_CLIENT_ERROR,
    LOAD_CAN_ADD_CLIENT_REQUEST,
    LOAD_CAN_ADD_CLIENT_SUCCESS,
    LOAD_CAN_ADD_CLIENT_FAILURE
} = ACTION_TYPES

export default {
    CLEAR: CLEAR_CAN_ADD_CLIENT,
    CLEAR_ERROR: CLEAR_CAN_ADD_CLIENT_ERROR,
    LOAD_REQUEST: LOAD_CAN_ADD_CLIENT_REQUEST,
    LOAD_SUCCESS: LOAD_CAN_ADD_CLIENT_SUCCESS,
    LOAD_FAILURE: LOAD_CAN_ADD_CLIENT_FAILURE
}